module.exports = __webpack_public_path__ + "img/BANNER-TECATE-COMIDA.2e933442.png";